<script setup>
const modelValue = defineModel({
    type: Array,
});
</script>

<template>
    <input
        v-model="modelValue"
        type="checkbox"
        class="border-primary text-primary checked:bg-primary focus:ring-primary disabled:border-neutrals-600 size-4 cursor-pointer rounded-sm bg-transparent disabled:cursor-not-allowed"
    />
</template>
